var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('weekly-dates',{attrs:{"date":_vm.date}}),_vm._v(" "),_c('schedules',{ref:"schedules",attrs:{"query":_vm.query}}),_vm._v(" "),_c('alarm-modal',{ref:"alarm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }